var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"voucherDetailsWrapper"}},[_c('media-only',{attrs:{"desktop":""}},[(_vm.uspBannerVisible)?_c('USPBanner'):_vm._e()],1),_vm._v(" "),_c(_vm.component,_vm._b({tag:"component"},'component',{
            //unification
            product: _vm.voucher,
            //unification
            productDetails: _vm.voucherDetails,
            relatedProducts: _vm.relatedProducts,
            teaser: _vm.teaser,
            hotelDetails: _vm.voucherProviderDetails,
            extraServicesAndInfos: []
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }